import React from "react";
import { useState } from "react";
import { Redirect } from "react-router-dom";
import VuiBox from "components/VuiBox";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";
import TenantUsersList from "components/TenantUsersList";
import TenantUserProfilePanel from "components/TenantUserProfilePanel";
import { useAuthz } from "context/AuthzContext";
import { useCompany } from "context/CompanyContext";

function TenantUsers() {
  const [refreshKey, setRefreshKey] = useState(0);
  const { isSuperAdmin, isTenantAdmin, tenantId } = useAuthz();
  const { companies, selectedCompanyId } = useCompany();
  const activeTenantId = isSuperAdmin ? selectedCompanyId || "" : tenantId || "";
  if (!isSuperAdmin && !isTenantAdmin) {
    return <Redirect to="/unauthorized" />;
  }

  const [selectedUser, setSelectedUser] = useState(null);

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <VuiBox py={3}>

        <VuiBox
          sx={{
            display: "grid",
            gridTemplateColumns: { xs: "minmax(0, 1fr)", sm: "360px minmax(0, 1fr)" },
            gap: 2,
            alignItems: "start",
          }}
        >
          <VuiBox sx={{ minWidth: 0, maxHeight: "calc(100vh - 200px)", overflow: "auto" }}>
            <TenantUsersList
              refreshKey={refreshKey}
              onSelectUser={setSelectedUser}
              selectedUserId={selectedUser?.uid || selectedUser?.id}
              onUsersLoaded={(users) => {
                setSelectedUser((previousUser) => {
                  const previousUserId = previousUser?.uid || previousUser?.id;
                  return users.find((user) => (user.uid || user.id) === previousUserId) || users[0] || null;
                });
              }}
            />
          </VuiBox>

          <VuiBox sx={{ minWidth: 0, maxHeight: "calc(100vh - 200px)", overflow: "auto" }}>
            <TenantUserProfilePanel
              tenantId={selectedUser?._tenantId || activeTenantId}
              selectedUser={selectedUser}
              onSaved={() => setRefreshKey((previous) => previous + 1)}
            />
          </VuiBox>
        </VuiBox>
      </VuiBox>
      <Footer />
    </DashboardLayout>
  );
}

export default TenantUsers;
